<template>
  <component
    :is="tag"
    v-bind="$attrs"
    class="button"
    :class="[
      typeClass,
      sizeClass,
      {
        button_loading: loading,
        button_disabled: disabled
      }
    ]"
    v-tooltip="tooltip"
    v-on="$listeners"
  >
    <loader
      v-if="loading"
      size="15px"
      border="3px"
      :type="loaderType"
      absolute
    />
    <slot></slot>
  </component>
</template>

<script>
import Loader from '@/components/Loader';

export default {
  props: {
    type: {
      type: String,
      default: 'secondary',
      validator(value) {
        return ['primary', 'secondary', 'negative'].includes(value);
      },
    },
    size: {
      type: String,
      default: 'md',
      validator(value) {
        return ['md', 'lg'].includes(value);
      },
    },
    tag: {
      type: String,
      default: 'button',
    },
    loading: Boolean,
    disabled: Boolean,
  },
  components: { Loader },
  data() {
    return {
      tooltip: null,
      tooltipTimeout: null,
    };
  },
  computed: {
    typeClass() {
      if (this.type === 'secondary') {
        return undefined;
      }

      return `button_${this.type}`;
    },
    sizeClass() {
      if (this.size === 'md') {
        return undefined;
      }

      return `button_size-${this.size}`;
    },
    loaderType() {
      if (this.type === 'negative') {
        return 'negative';
      }

      return 'primary';
    },
  },
  methods: {
    showTooltip({ content, duration = 5000 }) {
      clearTimeout(this.tooltipTimeout);

      this.tooltip = {
        content,
        trigger: 'manual',
        show: true,
      };

      this.tooltipTimeout = setTimeout(() => {
        this.tooltip = null;
      }, duration);
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  display: inline-block;
  position: relative;
  padding: 4px 8px;
  background: var(--bg);
  border: 1px solid lighten($primary, 20);
  border-radius: 2px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: var(--text-primary);
  cursor: pointer;
  word-break: break-word;
  text-align: center;

  &_size {
    &-lg {
      font-size: 16px;
      padding: 8px 16px;
    }
  }

  &_primary {
    background-color: var(--primary);
    color: #fff;
  }

  &_negative {
    background-color: var(--bg-danger);
    border-color: var(--bg-danger);
    color: #fff;
  }

  &_loading {
    pointer-events: none;
  }

  &_disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>
